import * as yup from 'yup';

export const forgotPasswordValidation = yup.object().shape({
  email: yup.string().required('Email is required').email('Please enter a valid email address'),
});

export const FieldNames = {
  emailField: 'email',
};

export const FieldLabels = {
  EMAIL: 'EMAIL',
};
